export default "__VITE_ASSET__D2BQW9al__"